import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left d-flex flex-column max-width" }
const _hoisted_2 = { class: "text-center mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.valid,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valid) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_container, {
          fluid: "",
          class: _normalizeClass([_ctx.containerClasses, "bg-blue-lighten-5"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", {
                class: _normalizeClass([_ctx.titleClasses, "font-weight-bold mb-4"])
              }, "Noch Fragen offen?", 2),
              _createElementVNode("p", {
                class: _normalizeClass([_ctx.subtitleClasses, "font-weight-regular"])
              }, " Melde dich gerne bei uns – wir helfen weiter! ", 2)
            ]),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.firstname,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                      counter: 16,
                      rules: _ctx.nameRules,
                      label: "Vorname",
                      clearable: "",
                      required: "",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.lastname,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event)),
                      counter: 16,
                      rules: _ctx.nameRules,
                      label: "Nachname",
                      clearable: "",
                      variant: "outlined",
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                      rules: _ctx.emailRules,
                      label: "E-mail",
                      variant: "outlined",
                      clearable: "",
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6",
                  class: "bg-blue-lighten-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      clearable: "",
                      chips: "",
                      label: "Welche Art von Fotografie interessiert Dich?",
                      items: ['Fotografie', 'Hochzeit', 'Social Media', 'Influencer', 'Sonstiges'],
                      variant: "outlined"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_number_input, {
                      label: "Geschätztes Budget in €",
                      "control-variant": "split",
                      variant: "outlined",
                      min: 100,
                      max: 100000
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      "model-value": _ctx.value,
                      rules: _ctx.rules,
                      label: "Weitere Details",
                      counter: "",
                      clearable: "",
                      variant: "outlined",
                      rows: "3"
                    }, null, 8, ["model-value", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.buttonSize),
                      type: "submit",
                      disabled: !_ctx.valid,
                      color: "primary",
                      large: "",
                      size: "x-large"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Anfrage senden ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}